var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jf-checkbox"},[_c('label',[_c('span'),_vm._v(" "+_vm._s(_vm.text)+"\n    ")]),(_vm.helpTooltip && _vm.helpTooltip.length)?_c('jf-help-tooltip',{staticClass:"help-tooltip",attrs:{"text":_vm.helpTooltip}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }